import ArrowLeftIcon from './arrow-left-icon';
import ArrowRightIcon from './arrow-right-icon';
export { ArrowLeftIcon, ArrowRightIcon, };
//# sourceMappingURL=index.js.map